import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { CoRoamSecurityComponent } from '../../components/co-roam-security/co-roam-security'
import { ClientDetailsProvider } from '../../providers/client-details/client-details';
import { AppState } from '../../config/state';

/**
 * Generated class for the SecurityPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-security',
  templateUrl: 'security.html',
})
export class SecurityPage {
  @ViewChild(CoRoamSecurityComponent) roamSecurity: CoRoamSecurityComponent;
  clientKeyword: string;
  viewType: any;
  menuSide: string = "left";

  constructor(public navCtrl: NavController, public navParams: NavParams, public clientDetails: ClientDetailsProvider, public state: AppState) {
    //this.currentDay = moment().toString();
    let self = this;
    this.state.burgerMenu && this.state.burgerMenu.menuSide ? this.menuSide = this.state.burgerMenu.menuSide : this.menuSide = "hidden";
    clientDetails.load().then(function (response) {
      self.clientKeyword = response.keyword;
      self.viewType = state.mode;
    });
    // console.log('nav params', this.navParams.data);
  }

  changeView(securityView) {
    // console.log('changed view to', securityView);
  }

  ngOnInit() {
    if (this.navParams.data.filter){
      // console.log(this.navParams.data.filter, 'the filter');
    };
  }
}



// WEBPACK FOOTER //
// ./src/pages/security/security.ts